import { Component, OnInit } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { BsDatepickerConfig } from 'ngx-bootstrap';
import { FormData } from '../Utils/form-data';
import { DynamoService } from '../utils/dynamo.service';
import { Router } from '@angular/router';
import { OtherFunds } from '../Utils/formdata.models';

@Component({
  selector: 'app-other-funds',
  templateUrl: './other-funds.component.html',
  styleUrls: ['./other-funds.component.css']
})
export class OtherFundsComponent implements OnInit {
  dataPosted = false;
  formOther: FormGroup;
  yesNoLookup;
  history = false;
  outsideCapitals = false;
  inputTypeNumbers = [true];
  nrSelect1 = 'yesNo';
  nrSelect2 = 'yesNo2';

  bsConfig: Partial<BsDatepickerConfig>;
  recaptcha: boolean;
  constructor(public formData: FormData, private dynamo: DynamoService, private router: Router) {
    dynamo.getLookupName('L_YesNo').subscribe(data => {
      this.yesNoLookup = data;
    }, error => {
      console.log('Lookup error: ', error);
    });
  }

  ngOnInit() {
    if (this.formData.investmentStrategyMain.isDataValid()) {
      this.bsConfig = {
        containerClass: 'theme-default',
        adaptivePosition: true
      };

      this.formData.otherFunds = new OtherFunds();

      this.formOther = this.formData.otherFunds.getFormGroup();
    } else {
      this.router.navigate(['investment-strategy-main']);
    }

  }

  public resolved(captchaResponse: string) {
    this.recaptcha = !!captchaResponse;
  }

  handleNumbers(numberValue, placeofInput) {
    this.inputTypeNumbers[placeofInput] = !isNaN(numberValue);
    return this.inputTypeNumbers[placeofInput];
  }

  chooseYesOrNo(event, boxNumber) {
    switch (event) {
      case 'Yes':
        if (boxNumber === 1) { this.history = true; }
        if (boxNumber === 2) { this.outsideCapitals = true; }
        break;
      case 'No':
        if (boxNumber === 1) { this.history = false; }
        if (boxNumber === 2) { this.outsideCapitals = false; }
        break;
    }
  }
  setProps() {
    if (!this.dataPosted) {
      this.dataPosted = true;
      this.formData.otherFunds.migrateFormData();
      this.dynamo.postData(this.formData.constructWebFormPlaceholder(), 'WebFormPlaceholder')
        .subscribe(data => {
          this.router.navigate(['/thank-you']);
        }, error => {
          console.log('Post Data Error:', error);
        });
    }
  }
}
